import React from 'react';
import Button from '@components/ui/Button/Button';
import styles from '@components/ui/Modal/Modal.module.css';
import logoutIcon from '@assets/header/logout.svg';

interface ProfileModalProps {
  isClosing?: boolean;
  onClose: () => void;
  onLogout: () => void;
  userName: string;
  userEmail: string;
}

const ProfileModal: React.FC<ProfileModalProps> = ({
  isClosing,
  onClose,
  onLogout,
  userName,
  userEmail,
}) => {
  const handleLogoutClick = () => {
    onLogout();
    onClose();
  };

  return (
    <div className={`${styles.profileModal} ${isClosing ? styles.closing : ''}`}>
      <div className={styles.modalTitle}>{userName}</div>
      <div className={styles.modalSubtitle}>{userEmail}</div>
      <div className={styles.modalSeparator}></div>
      <div className={styles.modalButtons}>
        <Button
          variant="text"
          size="md"
          fullWidth
          className={styles.menuItem}
          onClick={handleLogoutClick}
        >
          <img src={logoutIcon} alt="Logout icon" className={styles.buttonIcon} />
          Logout
        </Button>
      </div>
    </div>
  );
};

export default ProfileModal;
